module.exports = __webpack_public_path__ + "static/media/inprocess.4d5c575a.svg";